"use client";

import { PricingInsightFlagsProvider } from "@/contexts/PricingInsightFlagsContext";

/** Buyer price guidance on /request-item uses `usePriceInsight` → needs flags provider. */
export function RequestItemRouteProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  return <PricingInsightFlagsProvider>{children}</PricingInsightFlagsProvider>;
}
